import { useEffect, useState, useContext, Fragment } from "react";
import {
  Typography,
  Collapse,
  IconButton,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Grid,
  InputAdornment,
  FormControl,
  Select,
  MenuItem,
  Switch,
} from "@mui/material";
// import { Link } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
//Srcs
import "../Style/pagestyle.scss";
import FooterPagination from "../Components/Include/FooterPagination";
import LoadingPage from "../Components/Include/LoadingPage";
import EmptyData from "../Components/Include/EmptyData";
import {
  UPDATE_MATERIAL_IS_USE,
  GET_MATERIAL_PAGINATION,
} from "../Schema/Material";
import MaterialAction from "../Components/Material/MaterialAction";
import MaterialForm from "../Components/Material/MaterialForm";
import CreateIcon from "../Assets/create-icon.svg";
import {
  SelectCategory,
  SelectGroup,
  SelectSection,
  SelectLevelSection,
  SelectSize,
} from "../Components/Include/DynamicSelect";
import { AuthContext } from "../Context/AuthContext";
import ListMaterialUnit from "../Components/Material/ListMaterialUnit";

export default function Uniform() {
  const [loading, setLoading] = useState(true);
  const { setAlert, noneUserAccesse } = useContext(AuthContext);
  const [openCreate, setOpenCreate] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);
  //local
  const [sectionVal, setSectionVal] = useState({
    id: "66a445b1764aab2e5a12e658",
    title: "ឯកសណ្ឋាន",
  });
  //Live
  // const [sectionVal, setSectionVal] = useState({
  //   id: "66a445b1764aab2e5a12e658",
  //   title: "ឯកសណ្ឋាន",
  // });  
  const [groupVal, setGroupVal] = useState({ id: "", title: "" });
  const [categoryVal, setCategoryVal] = useState({ id: "", title: "" });
  const [levelSectionVal, setLevelSectionVal] = useState({ id: "", title: "" });
  const [sizeVal, setSizeVal] = useState({ id: "", title: "" });
  const [status, setStatus] = useState(true);
  const [expandedRows, setExpandedRows] = useState([]);
  // console.log("tableData", tableData);
  const handleOpenCreate = () => setOpenCreate(true);
  const handleCloseCreate = () => setOpenCreate(false);

  const { refetch } = useQuery(GET_MATERIAL_PAGINATION, {
    variables: {
      page,
      limit,
      pagination: true,
      keyword,
      isUse: status === "All" ? null : status,
      categoryId: categoryVal?.id || null,
      sectionId: sectionVal?.id || null,
      groupId: groupVal?.id || null,

      levelSectionId: levelSectionVal?.id ? levelSectionVal?.id : "",
      sizeId: sizeVal?.id ? sizeVal?.id : "",
    },
    onCompleted: ({ getMaterialPagination }) => {
      setTableData(getMaterialPagination?.data);
      setPaginationData(getMaterialPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      setLoading(true);
      console.log("Error::", err?.message);
    },
    pollInterval: 1000,
  });

  useEffect(() => {
    setLoading(true);
    refetch();
  }, [
    status,
    categoryVal?.id,
    sectionVal?.id,
    groupVal?.id,
    keyword,
    page,
    limit,
  ]);

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  const [updateMaterialIsUse] = useMutation(UPDATE_MATERIAL_IS_USE, {
    onCompleted: ({ updateMaterialIsUse }) => {
      setAlert(true, "success", updateMaterialIsUse?.message);
    },
    onError: (error) => {
      setAlert(true, "error", error?.message);
    },
  });

  const handleUpdateStatus = (id, status) => {
    updateMaterialIsUse({
      variables: { id, isUse: status },
    });
  };

  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => setWidth(window.innerWidth - 50);

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const handleAccordionChange = (index) => {
    const newExpandedRows = [...expandedRows];
    newExpandedRows[index] = !newExpandedRows[index];
    setExpandedRows(newExpandedRows);
  };

  //========== When Change Category ===========
  useEffect(() => {
    setSectionVal({ id: "66a445b1764aab2e5a12e658", title: "ឯកសណ្ឋាន" });
    setGroupVal({ id: "", title: "" });
    setStatus(true);
    setPage(1);
  }, [categoryVal?.id]);
  //========== When Change Section ===========
  useEffect(() => {
    setGroupVal({ id: "", title: "" });
    setStatus(true);
    setPage(1);
  }, [sectionVal?.id]);
  //========== When Change Group ===========
  useEffect(() => {
    setStatus(true);
    setPage(1);
  }, [groupVal?.id]);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        {/* <Stack direction="column" justifyContent="center">
          <Link className="page-link-title" to="/setting">
            <Typography className="page-title">ការកំណត់</Typography>
          </Link>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="slash-title">/</Typography>
        </Stack> */}
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">ឯកសណ្ឋាន</Typography>
        </Stack>
      </Stack>
      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className="header-text">ស្វែងរក</Typography>
            <TextField
              placeholder="ស្វែងរកឈ្មោះ ឬ កូដ"
              size="small"
              className="search-field"
              onChange={(e) => setKeyword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "black" }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          {noneUserAccesse(["StockController", "Proposer"]) ? null : (
            <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
              <Typography className="header-text">ជ្រើសរើសប្រភេទ</Typography>
              <SelectCategory
                className="search-field"
                setSelectedVal={setCategoryVal}
                selectedVal={categoryVal}
                isUse={false}
              />
            </Grid>
          )}

          {noneUserAccesse(["StockController", "Proposer"]) ? null : (
            <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
              <Typography className="header-text">ជ្រើសរើសផ្នែក</Typography>
              <SelectSection
                className="search-field"
                setSelectedVal={setSectionVal}
                selectedVal={sectionVal}
                disabled={true}
              />
            </Grid>
          )}

          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className="header-text">ជ្រើសរើសកម្រិតផ្នែក</Typography>
            <SelectLevelSection
              className="search-field"
              selectedVal={levelSectionVal}
              setSelectedVal={setLevelSectionVal}
              isUse={false}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className="header-text">ជ្រើសរើសក្រុម</Typography>
            <SelectGroup
              isUse={true}
              className="search-field"
              setSelectedVal={setGroupVal}
              selectedVal={groupVal}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className="header-text">ជ្រើសរើសទំហំ</Typography>
            <SelectSize
              className="search-field"
              selectedVal={sizeVal}
              setSelectedVal={setSizeVal}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className="header-text">ស្ថានភាពប្រើប្រាស់</Typography>
            <FormControl className="search-field" fullWidth size="small">
              <Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value="All">ទាំងអស់</MenuItem>
                <MenuItem value={true}>ប្រើប្រាស់</MenuItem>
                <MenuItem value={false}>មិនប្រើប្រាស់</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Box flexGrow={1} />
          <Grid item xs={6} sm={6} md={4} lg={3} xl={10}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpenCreate}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                បង្កើត
              </Button>
            </Stack>
            <MaterialForm
              open={openCreate}
              handleClose={handleCloseCreate}
              setRefetch={refetch}
              dialogTitle="Create"
              defaultSectionSelected={sectionVal}
            />
          </Grid>
        </Grid>
      </Box>
      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table" size="small">
            <TableHead className="header-row">
              <TableRow>
                <TableCell className="header-title-start" width="3%" />
                <TableCell className="header-title" width="3%">
                  ល.រ
                </TableCell>
                <TableCell className="header-title">ឈ្មោភាសាខ្មែរ</TableCell>
                {/* <TableCell className="header-title">ឈ្មោះអង់គ្លេស</TableCell> */}
                {/* <TableCell className="header-title">ប្រភេទ</TableCell> */}
                <TableCell className="header-title" width="10%">
                  តម្លៃ
                </TableCell>
                <TableCell className="header-title" width="10%">
                  ផ្នែក
                </TableCell>
                <TableCell className="header-title" width="10%">
                  កម្រិតនៃផ្នែក
                </TableCell>
                <TableCell className="header-title" width="5%">
                  ក្រុម
                </TableCell>
                <TableCell className="header-title" width="5%">
                  ឯកតា
                </TableCell>
                <TableCell className="header-title" width="5%">
                  ទំហំ
                </TableCell>
                <TableCell className="header-title" width="10%">
                  ចំណាំ
                </TableCell>
                <TableCell className="header-title" width="7%" align="right">
                  ស្ថានភាព
                </TableCell>
                <TableCell className="header-title-end" width="10%"></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={12} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={12} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => (
                      <Fragment key={index}>
                        <TableRow className="body-row">
                          <TableCell className="body-cell">
                            <IconButton
                              aria-label="expand row"
                              size="small"
                              onClick={() => handleAccordionChange(index)}
                            >
                              {expandedRows[index] ? (
                                <KeyboardArrowUpIcon
                                  sx={{ color: "#00A0DC" }}
                                />
                              ) : (
                                <KeyboardArrowDownIcon
                                  sx={{ color: "#00A0DC" }}
                                />
                              )}
                            </IconButton>
                          </TableCell>
                          <TableCell className="body-cell">
                            {index + paginationData?.slNo}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                            onClick={() => handleAccordionChange(index)}
                          >
                            {row?.materialKhName}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                            onClick={() => handleAccordionChange(index)}
                          >
                            $ {row?.defaultPrice}
                          </TableCell>
                          {/* <TableCell
                            className="body-cell"
                            onClick={() => handleAccordionChange(index)}
                          >
                            {row?.materialEnName}
                          </TableCell> */}
                          {/* <TableCell
                            className="body-cell"
                            onClick={() => handleAccordionChange(index)}
                          >
                            {row?.categoryId?.categoryKhName}
                          </TableCell> */}
                          <TableCell
                            className="body-cell"
                            onClick={() => handleAccordionChange(index)}
                          >
                            {row?.sectionId?.sectionKhName}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                            onClick={() => handleAccordionChange(index)}
                          >
                            {row?.levelSectionId?.levelSectionKhName}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                            onClick={() => handleAccordionChange(index)}
                          >
                            {row?.groupId?.groupKhName}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.smallUnitId?.unitKhName}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                            onClick={() => handleAccordionChange(index)}
                          >
                            {row?.sizeId?.sizeKhName}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                            onClick={() => handleAccordionChange(index)}
                          >
                            {row?.remark}
                          </TableCell>
                          <TableCell className="body-cell" align="right">
                            <Switch
                              size="small"
                              checked={row.isUse}
                              onChange={(e) =>
                                handleUpdateStatus(row?._id, !row?.isUse)
                              }
                            />
                          </TableCell>
                          <TableCell className="body-cell action-cell">
                            <MaterialAction
                              editData={row}
                              setRefetch={refetch}
                            />
                          </TableCell>
                        </TableRow>

                        {/* Accouding */}
                        <TableRow className="collapse-row">
                          <TableCell
                            className="body-cell"
                            style={{ paddingBottom: 0, paddingTop: 0 }}
                            colSpan={12}
                          >
                            <Collapse
                              in={expandedRows[index]}
                              timeout="auto"
                              unmountOnExit
                            >
                              <Box sx={{ margin: 1 }}>
                                <Typography>
                                  Detail for {row.name_en}
                                </Typography>
                                <Table
                                  className="table"
                                  aria-label="simple table"
                                  size="small"
                                >
                                  <TableBody>
                                    <ListMaterialUnit materialId={row} />
                                  </TableBody>
                                </Table>
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </Fragment>
                    ))}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
      </Box>
      <Stack
        direction="row"
        justifyContent="right"
        className="pagination-container"
      >
        <FooterPagination
          limit={limit}
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
        />
      </Stack>
    </div>
  );
}
